module.exports = __webpack_public_path__ + "img/pmgx2.428577e4.png";